import { Injectable } from '@angular/core';
import { environment } from '@dxp/core/environment';
import { IAgentReport, IQueueWithChannelsReport } from '@dxp/core/models';
import { Subject } from 'rxjs';
import { SignalRHubService } from '../signalr.hub.service';

@Injectable({
    providedIn: 'root',
})
export class AggregationsHubService extends SignalRHubService {
    readonly #agentReportSubject = new Subject<IAgentReport>();
    readonly #queueReportSubject = new Subject<IQueueWithChannelsReport>();

    agentReport$ = this.#agentReportSubject.asObservable();
    queueReport$ = this.#queueReportSubject.asObservable();

    name = 'Aggregation';
    url = `${environment.aggregationsUrl}/today/hub`;

    protected override registerHandlers() {
        this.hubConnection.on(
            'ReceiveTodaysAgentReportData',
            (agentReport: IAgentReport) => {
                this.messageReceived();

                this.logger.verbose(
                    'Aggregation Hub Service (ReceiveTodaysAgentReportData) ->',
                    agentReport,
                );
                this.logger.table(agentReport);

                this.#agentReportSubject.next(agentReport);
            },
        );

        this.hubConnection.on(
            'ReceiveTodaysQueueData',
            (queueReport: IQueueWithChannelsReport) => {
                this.messageReceived();

                this.logger.verbose(
                    'Aggregation Hub Service (ReceiveTodaysQueueData) ->',
                    queueReport,
                );
                this.logger.table(queueReport);

                this.#queueReportSubject.next(queueReport);
            },
        );
    }

    protected override unregisterHandlers() {
        this.hubConnection.off('ReceiveTodaysAgentReportData');
        this.hubConnection.off('ReceiveTodaysQueueData');
    }
}
